import { Card, CardContent, Grid, Tab, Tabs, tabsClasses } from '@mui/material';
import { Layout } from 'components/layout';
import { SyntheticEvent, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import config from 'config';
import { decodeHashId } from 'lib/helpers/hasher';
import UserProfile from './userProfile';
// import Cookies from 'universal-cookie';
import DataGaji from '../components/dataGaji';
import DataKeluarga from '../components/dataKeluarga';
import DataPekerjaan from '../components/dataPekerjaan';
import DataPersonal from '../components/dataPersonal';

const MyProfilePage = () => {
    const theme = useTheme();
    const userData = JSON.parse(decodeHashId(localStorage.getItem(config.cookieUser)));
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Layout headerTitle="My Profile" pageTitle="My Profile">
            <Grid container direction="column" spacing={20}>
                <Grid item container spacing={20}>
                    <Grid item xs={12} md={5} lg={5}>
                        <Card>
                            <CardContent>
                                <UserProfile userData={userData} />
                                <DataPersonal userData={userData} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={7} lg={7}>
                        <Card sx={{ p: 5 }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                aria-label="visible arrows tabs example"
                                sx={{
                                    [`& .${tabsClasses.scrollButtons}`]: {
                                        '&.Mui-disabled': { opacity: 0.3 }
                                    }
                                }}
                            >
                                <Tab label="Data Pekerjaan" />
                                <Tab label="Data Gaji" />
                                <Tab label="Data Keluarga" />
                            </Tabs>
                            {tabValue === 0 && <DataPekerjaan userData={userData} />}
                            {tabValue === 1 && <DataGaji userData={userData} />}
                            {tabValue === 2 && <DataKeluarga userData={userData} />}
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
        </Layout>
    );
};

export default MyProfilePage;
